<template>
  <div>
    <!-- BOTÓN (esto reemplaza tu v-btn actual) -->
    <v-tooltip bottom color="primary">
      <template #activator="{ on, attrs }">
        <v-btn
          color="white"
          class="primary--text"
          v-bind="attrs"
          v-on="on"
          :loading="loading"
          :disabled="!ciclo"
          @click="dialog = true"
        >
          <v-icon left>fa-file-download</v-icon>
          Generar reporte
        </v-btn>
      </template>
      <span>Abre las opciones de reportes</span>
    </v-tooltip>

    <!-- DIALOG -->
    <v-dialog v-model="dialog" max-width="520" persistent>
      <v-card>
        <v-card-title class="d-flex flex-column align-start">
          <div style="font-size: 24px; font-weight: 600;">
            Reportes de Becas Externas
          </div>
          <div style="font-size: 22px; font-weight: 700; color: #8b0000;">
            Ciclo {{ ciclo || '—' }}
          </div>
        </v-card-title>

        <v-card-text>
          <!-- PANEL OPCIONES -->
          <v-expansion-panels flat>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-icon left>fa-sliders-h</v-icon>
                Opciones resumen general
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <!-- FILTRO ACTIVO/INACTIVO -->
                <div class="text-subtitle-1 font-weight-medium mb-1">Estado de becarios</div>
                <v-radio-group v-model="selectActivo" row class="mt-0">
                  <v-radio label="Solo activos" value="activos" color="success" />
                  <v-radio label="Solo inactivos" value="inactivos" color="error" />
                  <v-radio label="Todos" value="todos" />
                </v-radio-group>

                <v-divider class="mb-3" />

                <div class="text-subtitle-1 font-weight-medium mb-2">
                  Filtrar por
                </div>

                <v-radio-group v-model="filtro" row>
                  <v-radio label="Sin filtrar" value="none" />
                  <v-radio label="Carrera" value="career" />
                  <v-radio label="Institución" value="institution" />
                </v-radio-group>

                <div v-if="filtro === 'career'" class="mt-3">
                  <v-autocomplete
                    v-model="selectCarrera"
                    :items="carreras"
                    label="Carrera"
                    no-data-text="Sin resultados"
                    placeholder="Seleccionar..."
                    clearable
                    dense
                  />
                </div>

                <div v-if="filtro === 'institution'" class="mt-3">
                  <v-autocomplete
                    v-model="selectInstitucion"
                    :items="instituciones"
                    item-text="nombre"
                    item-value="institucionPatrocinadoraId"
                    label="Institución"
                    no-data-text="Sin resultados"
                    placeholder="Seleccionar..."
                    clearable
                    dense
                  />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- BOTÓN RESUMEN GENERAL -->
          <v-btn
  block
  color="success"
  class="mt-3"
  :loading="loading"
  :disabled="!ciclo"
  @click="emitReporteCompleto"
>
  <v-icon left>fa-file-excel</v-icon>
  REPORTE COMPLETO
</v-btn>

        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text color="primary" @click="closeDialog">Cerrar</v-btn>


         </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'ReportesSolicitudesDialog',

  props: {
    ciclo: { type: String, default: '' },
    carreras: { type: Array, default: () => [] },
    instituciones: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    activoInicial: { type: String, default: 'activos' } // activos | inactivos | todos
  },

  data() {
    return {
      dialog: false,
      filtro: 'none',
      selectCarrera: null,
      selectInstitucion: null,
      selectActivo: this.activoInicial
    }
  },

  watch: {
    activoInicial(val) {
      this.selectActivo = val
    }
  },

  computed: {
    puedeEjecutar() {
      if (!this.ciclo) return false
      if (this.filtro === 'career') return !!this.selectCarrera
      if (this.filtro === 'institution') return !!this.selectInstitucion
      return true
    }
  },

  methods: {
   resetFiltros() {
  this.filtro = 'none'
  this.selectCarrera = null
  this.selectInstitucion = null
  this.selectActivo = this.activoInicial
},
closeDialog() {
  this.dialog = false
  this.resetFiltros()
}
,
  
      emitReporteCompleto() {
    this.$emit('reporte-completo', {
      ciclo: this.ciclo,
      filtro: this.filtro,
      carrera: this.selectCarrera,
      institucionId: this.selectInstitucion,
      activo: this.selectActivo
    })
    this.dialog = false
    this.resetFiltros()
  }
  }
}
</script>
